<template>
  <section v-if="dataLoaded">
    <!-- Mobile layout -->
    <v-list v-if="isMobile">
      <v-list-group no-action class="pa-0">
        <template v-slot:activator>
          <v-list-item class="pa-0">
            <v-list-item-avatar class="my-0 px-0">
              <v-img
                max-width="25"
                max-height="25"
                :src="
                  require(`@/assets/countryIcons/${userLanguageObj.EnglishName}.png`)
                "
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle>
                {{ userLanguageObj.LocalName }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item
          v-for="(item, index) in allLanguages"
          :key="index"
          class="pl-8"
          @click="updateLanguage(item)"
        >
          <v-list-item-avatar class="my-1 mr-2">
            <v-img
              max-width="25"
              max-height="25"
              :src="require(`@/assets/countryIcons/${item.EnglishName}.png`)"
            ></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle
              v-text="item.LocalName"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>

    <!-- Non-mobile layout -->
    <v-menu
      v-else
      bottom
      left
      nudge-bottom="30"
      transition="scroll-y-transition"
      :open-on-hover="true"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          class="pa-0 px-md-2"
          elevation="0"
          color="grey"
          light
          small
          text
          v-on="on"
        >
          <v-img
            max-width="25"
            max-height="25"
            class="ma-1"
            :src="
              require(`@/assets/countryIcons/${userLanguageObj.EnglishName}.png`)
            "
          ></v-img>
          <div :class="{ 'primary-font-color': isTransparent }"
          :color="isTransparent ? '' : 'primary'">
          <v-icon v-if="isTransparent" right >keyboard_arrow_down</v-icon>
          <v-icon v-else right color="primary">keyboard_arrow_down</v-icon>
        </div>
        </v-btn>
      </template>
      <v-card>
        <v-list>
          <v-list-item-group>
            <template v-for="(item, index) in allLanguages">
              <v-list-item :key="index" @click="updateLanguage(item)">
                <template v-slot:default>
                  <v-list-item-avatar class="my-1 mr-2">
                    <v-img
                      max-width="25"
                      max-height="25"
                      :src="
                        require(`@/assets/countryIcons/${item.EnglishName}.png`)
                      "
                    ></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="item.LocalName"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
  </section>
</template>

<script>
import doRequest from '@/api/dssRequest';

export default {
  name: 'HeaderTranslations',
  props: {
    isMobile: Boolean,
    isTransparent: Boolean,
  },
  computed: {
    userLanguageObj() {
      return this.$store.getters['auth/userLanguage'];
    },
    allLanguages() {
      return this.$store.getters.getAllLanguages;
    },
    dataLoaded() {
      if (
        this.userLanguageObj != null &&
        Object.keys(this.userLanguageObj).length > 0 &&
        this.allLanguages != null &&
        this.allLanguages.length > 0
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    updateLanguage(language) {
      // check if the user choose the same language
      if (language.LanguageId === this.userLanguageObj.LanguageId) {
        return;
      }

      this.$store.commit('auth/setUserLanguage', language);

      if (this.$store.getters['auth/userName'] === '') {
        this.$router.go();
        return;
      }

      doRequest(
        () => {
          this.$router.go();
        },
        () => {},
        'updateLanguage',
        this.$store.getters['auth/userName'],
        {}
      );
    },
  },
};
</script>
